module.exports = __webpack_public_path__ + "static/img/company-component-cove-3.99c7da6c.jpg";